import Auth from '../modules/Authentication'
import {apiUrl} from '../variables/index'
import {handleErrors, handleResponse} from '../modules/Utils'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
export default class Dropdowns {
  constructor() {
    this.auth = new Auth()
  }

  read = (dropdownID, attributeID) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}dropdowns/${dropdownID}/${attributeID}`, {headers})
      .then(handleErrors)
      .then(handleResponse)
  }
}
